import React from 'react'
import '../courses.css'
import Menubar from '../../home/menubar/Menubar'
import Address from '../../home/footer/Address'
import Carousel from '../../home/carousel/Carousel'
import { dtpImg, dtpData, dtp_gif } from '../../home/data'
import Hower from '../../home/hower/Hower'
import Typewriter from '../../home/lazy loader/Typewriter'
import ScrollToTopProgress from '../../home/header/ScrollToTopProgress'
import Header from '../../home/header/Header'

function Dtp() {
  const imgUrl = dtpImg;
  const txt = dtpData;
  const gif = dtp_gif;
  return (
    <div>
        <Header/>
        <Menubar/>
        <Carousel imgUrl={imgUrl}/>
        <Hower gif={gif}/>
        <Typewriter txt={txt}/>

        
        <div className='pannel-container'>
          <div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
        <p className='panel-title'>ADOBE PHOTOSHOP Level-1</p>
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>What is ADOBE PHOTOSHOP ?</li>
          <li className='list'>Getting to Know the Work Area</li>
          <li className='list'>Starting to work in Adobe Photoshop</li>
          <li className='list'>Using the tools</li>
          <li className='list'>Sampling a color</li>
          <li className='list'>Working with tools and tool properties</li>
          <li className='list'>Undoing actions in Photoshop</li>
          <li className='list'>More about panels and panel locations</li>
          <li className='list'>Basic Photo Corrections</li>
          <li className='list'>Working with Selections</li>
          <li className='list'>Layer Basics</li>
          <li className='list'>Masks and Channels</li>
          <li className='list'>Typographic Design</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
        <p className='panel-title'>ADOBE PHOTOSHOP Level-2</p>
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>Quick Fixes</li>
          <li className='list'>Vector Drawing Techniques</li>
          <li className='list'>About bitmap images and vector graphics</li>
          <li className='list'>Advanced Compositing</li>
          <li className='list'>Painting with the Mixer Brush</li>
          <li className='list'>About the Mixer Brush</li>
          <li className='list'>Upscaling a low-resolution image</li>
          <li className='list'>Moving objects with the Content-Aware Move tool</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingThree">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
        <p className='panel-title'>PAGEMAKER Level-1</p>
      </button>
    </h2>
    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>What is PAGEMAKER ?</li>
          <li className='list'>Creating and Opening Publication</li>
          <li className='list'>Using the Toolbox</li>
          <li className='list'>Working with palettes, text and graphics</li>
          <li className='list'>Starting a publication from the template</li>
          <li className='list'>Saving and closing the publication</li>
          <li className='list'>Positioning ruler guides</li>
          <li className='list'>Typing Text</li>
          <li className='list'>Formatting Graphics</li>
          <li className='list'>Creating columns</li>
          <li className='list'>Creating Styles</li>
          <li className='list'>Changing type style & Alignment</li>
          <li className='list'>Rotating and moving of text block and graphics</li>
          <li className='list'>Placing text file</li>
          <li className='list'>Setting Tab</li>
          <li className='list'>Indents</li>
          <li className='list'>Leaders copying graphics between publication</li>
          <li className='list'>Positioning and resizing the logo</li>
          <li className='list'>Constructing a publication</li>
          <li className='list'>Setting up pages</li>
          <li className='list'>Changing documents setup</li>
          <li className='list'>Using master pages</li>
          <li className='list'>Choosing a measurement system and setting up rulers</li>
          <li className='list'>Adjusting layout</li>
          <li className='list'>Numbering pages</li>
          <li className='list'>Rearranging pages</li>
          <li className='list'>Creating Running headers & Footers</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingFour">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
        <p className='panel-title'>PAGEMAKER Level-2</p>
      </button>
    </h2>
    <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
            <li className='list'>Importing Text</li>
            <li className='list'>Threading Text Blocks</li>
            <li className='list'>Balancing Columns</li>
            <li className='list'>Edit Story</li>
            <li className='list'>Customizing the dictionary</li>
            <li className='list'>Hyphenation</li>
            <li className='list'>Leading frames layers</li>
            <li className='list'>Locking</li>
            <li className='list'>Objects wrapping text around graphics</li>
            <li className='list'>Cropping a graphics</li>
            <li className='list'>Using libraries assembling publication into a book</li>
            <li className='list'>Indexing a publication</li>
            <li className='list'>Creating table of contents</li>
            <li className='list'>Applying Color</li>
            <li className='list'>Edit Color</li>
            <li className='list'>Creating Custom Colors</li>
            <li className='list'>Color Libraries</li>
            <li className='list'>Table Editor</li>
            <li className='list'>Importing, linking and exporting graphics</li>
            <li className='list'>OLE(Object Linking and Embedding)</li>
            <li className='list'>TIFF image</li>
            <li className='list'>PDF HTML formats</li>
            <li className='list'>Printing of publication proof corrections with appropriate proof reading marks</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingFive">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
        <p className='panel-title'>CORELDRAW</p>
      </button>
    </h2>
    <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>What is CORELDRAW ?</li>
          <li className='list'>Navigate the CorelDRAW interface</li>
          <li className='list'>Explore viewing modes and customizing options</li>
          <li className='list'>Create and manipulate objects</li>
          <li className='list'>Outline, fill, and transform objects</li>
          <li className='list'>Use layers and special effects</li>
          <li className='list'>Create and edit images and text</li>
          <li className='list'>Use tools, palettes, symbols, clipart, and work with bitmaps</li>
          <li className='list'>Save, and print design layouts</li>
          <li className='list'>Apply styles and templates</li>
          <li className='list'>Create animations, sprites, and interactive movies</li>

        </ul>
      </div>
    </div>
  </div>
          </div>
        </div>

        <div className="table-header">
	<h4><u><b>COURSE DETAILS :</b></u></h4>
<table className="table">
  <thead>
	<tr>
	<th colSpan="2" className="heading">DESKTOP PUBLISHING</th>
	</tr>
</thead>
<tbody>
<tr>
	<th>Overview</th>
	<td>This Adobe On-Demand class will cover have the same topics elearning topics that are covered in the Adobe Photoshop Core Skills: Level 1 and Level 2 classes through the elearning web edition of the text. This class also includes expanded Photoshop tutorials and related labs which are designed to reinforce new skills and prepare the user for the Adobe ACA Certification exam for Photoshop. It is not required that the student take the exams.
		</td>
</tr>
<tr>
	<th>Version Note</th>
	<td>Our Creative Cloud classes upgrade to the latest CC version as soon as new official training materials are released from Adobe. This is typically 2 to 4 months from a new software release. In addition, the expanded tutorials are oriented toward the Adobe ACA certification exams. Those tutorials are typically updated within 6 months of a new exam release.</td>
</tr>
<tr>
	<th>Prerequisites</th>
	<td>Basic computer and file management skills are required for Core Skills level Adobe courses. Students should know how to - locate, copy and open files; create folders; arrange, re-size, minimize and maximize application windows; start and exit programs; manage use of multiple programs simultaneously; and switch between open programs.</td>
</tr>
<tr>
	<th>Course Outline</th>
	<td>You will be able to select all or some of the topics below from the Adobe Official Workbook, elearning web edition. In addition, you will have access to the expanded tutorials related to these topics.</td>
</tr>
<tr>
	<th>PageMaker</th>
	<td>Adobe PageMaker enables you to create professional-looking publications for print and the web, or convert them to PDF (Portable Document Format) directly from within the application. PageMaker has been around since 1985 when it was known as Aldus PageMaker.</td>
</tr>
<tr>
	<th>Coreldraw</th>
	<td>CorelDRAW training imparts knowledge and skills to understand and use different features and tools of CorelDRAW software. Participants learn how to use this vector-illustration and page-layout application to present objects, layers, and pages in an effective and presentable form. A large collection of fonts, clip art, and editing tools enables the user to create logos, brochures, website graphics, illustrations and other artwork. The trained candidates can develop the designs to meet the computer graphics need of various applications.</td>
</tr>
</tbody>
</table>
</div>

        <Address/>
        <ScrollToTopProgress/>
    </div>
  )
}

export default Dtp